import type { FeatureAccessResponse } from 'src/features/subscription/api';

import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';

import { subscriptionService } from 'src/features/subscription/api';

export const useSubscriptionAccess = () => {
  const checkFeatureAccessMutation = useMutation({
    mutationFn: (featureName: string) => subscriptionService.checkFeatureAccess(featureName),
  });

  const checkFeatureAccess = useCallback(
    async (featureName: string): Promise<FeatureAccessResponse> =>
      checkFeatureAccessMutation.mutateAsync(featureName),
    [checkFeatureAccessMutation]
  );

  return {
    checkFeatureAccess,
    isCheckingFeatureAccess: checkFeatureAccessMutation.isPending,
  };
};
